import { render, staticRenderFns } from "./menupopout.vue?vue&type=template&id=728380e8&"
import script from "./menupopout.vue?vue&type=script&lang=js&"
export * from "./menupopout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports